import { SearchX } from "lucide-react";

export function EmptyState({ title = "Ничего не найдено", description }: { title?: string; description: string }) {
  return (
    <div className="empty-state">
      <span><SearchX size={24} aria-hidden="true" /></span>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}
